import { FieldDefinitionsUtilities } from './FieldDefinitions.utilities.mjs';

class SuggestionQueryUtilities {
  static #_DEFAULT_LIMIT = 10;
  static #_DEFAULT_LOCALE = 'en';
  static #_MAX_CODE_UNIT = 0xffff;

  static buildValueSuggestionQuery(field, prefix, fieldDefinitions, options = {}) {
    FieldDefinitionsUtilities.assertValid(fieldDefinitions);
    if (typeof prefix !== 'string') {
      throw new TypeError('PREFIX_MUST_BE_STRING');
    }
    const declaration = fieldDefinitions.fields[field];
    if (declaration === undefined) {
      throw new Error(`FIELD_NOT_DEFINED: ${field}`);
    }
    let limit = SuggestionQueryUtilities.#_DEFAULT_LIMIT;
    if (options.limit !== undefined) {
      limit = options.limit;
    }
    let locale = SuggestionQueryUtilities.#_DEFAULT_LOCALE;
    if (options.locale !== undefined) {
      locale = options.locale;
    }
    const source = FieldDefinitionsUtilities.resolveSuggestionSource(declaration);
    if (source === 'none') {
      return { type: 'static', values: [] };
    }
    if (source === 'static') {
      return SuggestionQueryUtilities.#_buildStaticSpec(declaration, prefix, limit);
    }
    return SuggestionQueryUtilities.#_buildQuerySpec(field, prefix, limit, locale);
  }

  static #_buildStaticSpec(declaration, prefix, limit) {
    let values = declaration.values;
    if (values === undefined) {
      values = [];
    }
    const lowered = prefix.toLowerCase();
    const matched = values
      .filter((value) => String(value).toLowerCase().startsWith(lowered))
      .slice(0, limit);
    return { type: 'static', values: matched };
  }

  static #_buildQuerySpec(field, prefix, limit, locale) {
    let filter = {};
    if (prefix !== '') {
      const constraints = { $gte: prefix };
      const successor = SuggestionQueryUtilities.#_prefixSuccessor(prefix);
      if (successor !== null) {
        constraints.$lt = successor;
      }
      filter = { [field]: constraints };
    }
    return {
      type: 'query',
      field,
      filter,
      collation: { locale, strength: 2 },
      limit
    };
  }

  static #_prefixSuccessor(prefix) {
    const lastCode = prefix.charCodeAt(prefix.length - 1);
    if (lastCode >= SuggestionQueryUtilities.#_MAX_CODE_UNIT) {
      return null;
    }
    return prefix.slice(0, -1) + String.fromCharCode(lastCode + 1);
  }
}

export { SuggestionQueryUtilities };
export default SuggestionQueryUtilities;
